import { createContext } from "react";
import { WIDGET_TYPE } from "../domain";

const PageContext = createContext({
  operators: [],
  setOperators: () => {},
  tableDataset: {},
  setTableDataset: () => {},
  setRawApiData: () => {},
  setWidgetType: () => {},
  widgetType: WIDGET_TYPE.default.id,
  isSubmitting: false,
  setIsSubmitting: () => {},
  filterValues: {},
  setFilterValues: () => {}
});

export default PageContext;
